import PropTypes from "prop-types";

/*
    Representation of src/ssaw/portal/template_serializers/modules/product_card.py
*/
export const ProductCardPropType = PropTypes.shape({
    affiliate_promo_url: PropTypes.string,
    algolia_metadata: PropTypes.object,
    context_type: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    description: PropTypes.string,
    designer_name: PropTypes.string.isRequired,
    designer_slug: PropTypes.string.isRequired,
    detail_lead_enabled: PropTypes.bool,
    discount_info: PropTypes.string,
    free_shipping: PropTypes.bool.isRequired, // Default false
    full_price_machine_readable_integer_string: PropTypes.string,
    full_price_with_currency_symbol: PropTypes.string,
    gender: PropTypes.oneOf(["M", "F"]),
    has_variant: PropTypes.bool.isRequired,
    icon_enabled: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    image_alt_text: PropTypes.string.isRequired,
    image_url: PropTypes.string,
    in_stock: PropTypes.bool.isRequired,
    is_affiliate: PropTypes.bool.isRequired,
    lead_enabled: PropTypes.bool.isRequired,
    lead_url: PropTypes.string,
    link_id: PropTypes.number,
    on_promotion: PropTypes.bool.isRequired,
    overlay_enabled: PropTypes.bool.isRequired,
    retailer_name: PropTypes.string.isRequired,
    sale_badge: PropTypes.string,
    sale_discount: PropTypes.number,
    sale_price_machine_readable_integer_string: PropTypes.string,
    sale_price_with_currency_symbol: PropTypes.string,
    short_description: PropTypes.string,
    show_offer_meta: PropTypes.bool.isRequired,
    show_retailer_as_affiliate: PropTypes.bool.isRequired,
    slug: PropTypes.string.isRequired,
    uid: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    use_lazy_images: PropTypes.bool.isRequired,
    use_new_tab_logic: PropTypes.bool.isRequired,
    use_overlay_on_mobile: PropTypes.bool.isRequired,
});
